<script setup lang="ts">
import i18n from '@/lang/i18n';

</script>
<template>
  <div class="my-6">
    <h3 class="mt-0 mb-4 d-flex justify-center">
      {{ i18n.global.t('pages.dailyReports.combineRollbackForm.registerModal.body') }}
    </h3>
    <div class="text-title-large d-flex justify-center text-red">
      {{ i18n.global.t('pages.dailyReports.combineRollbackForm.registerModal.announce') }}
    </div>
  </div>
</template>
<style scoped>
.text-title-large {
  font-size: 17px;
}
.text-label-large {
  font-size: 15px;
}
</style>
